import { useEffect } from 'react';
import TagManager from 'react-gtm-module';
import { useRef, useCallback } from 'react';
import { useStepsContext } from '../../Hooks/useStepsContext';
import { useMediaQuery } from '../../Hooks/useMediaQuery';
import { removeSessionToken, sendAppointmentToRedTrack } from '../../Utils/api';
import steps from '../../Utils/constants';
import { IS_LOCAL } from '../../Utils/environment';

/* After booking redirects to Allybot v1.0 'confirmation' page */
export default function CalendlyBookingPage() {
  const { state, phoneLink, videoLink } = useStepsContext();
  const phoneIframeRef = useRef(null);
  const videoIframeRef = useRef(null);

  const mw423px = useMediaQuery('(min-width: 423px)');
  const mw650px = useMediaQuery('(min-width: 650px)');

  let height = 'calc(100% - 8.5rem)';
  if (mw423px) height = 'calc(100% - 8.5rem)';
  if (mw650px) height = 'calc(100% - 5.4rem)';

  const widgetStyles = {
    position: 'absolute',
    left: '3rem',
    right: '3rem',
    height,
    maxWidth: '64rem',
    width: 'calc(100% - 6rem)',
    margin: '0 auto',
  };

  const notVisibleStyles = {
    display: 'none',
    visibility: 'hidden',
    width: 0,
    height: 0,
  };

  // Tracking de booking exitoso via window message
  const handleGHLMessage = useCallback(async (event) => {
    //console.log('enters to callback', event.origin, event.data, event.type, event, JSON.stringify(event));

    if (event.origin !== 'https://api.leadconnectorhq.com') return;

    const data = event.data;

    // GHL dispara eventos: 'slot-selected', 'booking-confirmed'
    /*if (data.type === 'slot-selected') {
      if (!state.name.toLowerCase().includes('test')) {
        TagManager.dataLayer({
          dataLayer: { event: 'allybot2_date_time_selected' }
        });
      }
    }*/

    if (data.indexOf('msgsndr-booking-complete')>=0) {
      if (!state.name.toLowerCase().includes('test')) {
        TagManager.dataLayer({
          dataLayer: { event: 'allybot2_booking_scheduled' }
        });
        await sendAppointmentToRedTrack(state.params?.clickId);
      }
      removeSessionToken();
    }
  }, [state.name, state.params]);

  useEffect(() => {
    window.addEventListener('message', handleGHLMessage);
    return () => window.removeEventListener('message', handleGHLMessage);
  }, [handleGHLMessage]);

  useEffect(() => {
    if (state.calendlyLink && !state.name.toLowerCase().includes('test')) {
      TagManager.dataLayer({
        dataLayer: { event: 'allybot2_booking_page_viewed' }
      });
    }
  }, [state.calendlyLink, state.name]);

  // Construir URLs con query params

  /*
   * A booking calendar created in GoHighLevel specifically for development. Set VITE_DEV_BOOKING_URL
   * to its widget URL and both iframes point at it, so the last step can be exercised end to end
   * without scheduling an appointment with a real seller. Left empty, a local run shows a
   * placeholder instead: the real calendars must never be reachable from a developer machine.
   */
  const devBookingUrl = import.meta.env.VITE_DEV_BOOKING_URL;

  const withLead = (url) =>
    `${url}${url.includes('?') ? '&' : '?'}full_name=${encodeURIComponent(state.name)}&email=${encodeURIComponent(state.email)}`;

  const phoneUrl = withLead(devBookingUrl || `https://api.leadconnectorhq.com/widget/booking/${phoneLink}`);

  const videoUrl = withLead(devBookingUrl || `https://api.leadconnectorhq.com/widget/booking/${videoLink}`);

  if (IS_LOCAL && !devBookingUrl) {
    return (
      <div className="calendlyWrapper" style={state.step !== steps.CALENDLY_PAGE ? notVisibleStyles : {}}>
        <h1 className="calendlyHeading">Select A Convenient Time Here!</h1>

        <div style={{ ...widgetStyles, display: 'grid', placeItems: 'center', textAlign: 'center' }}>
          <p>
            Booking widget disabled on localhost so no real appointment is scheduled.
            <br />
            Set <code>VITE_DEV_BOOKING_URL</code> to a GoHighLevel calendar created for development to
            enable it.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="calendlyWrapper" style={state.step !== steps.CALENDLY_PAGE ? notVisibleStyles : {}}>
      <h1 className="calendlyHeading">Select A Convenient Time Here!</h1>

      <iframe
        ref={phoneIframeRef}
        src={phoneUrl}
        style={state.calendlyLink === phoneLink ? widgetStyles : notVisibleStyles}
        scrolling="no"
      />

      <iframe
        ref={videoIframeRef}
        src={videoUrl}
        style={state.calendlyLink === videoLink ? widgetStyles : notVisibleStyles}
        scrolling="no"
      />

    </div>
  );
}
